import { Box, Table, Text } from '@factorialco/deprecated-design-system'
import groupBy from 'lodash/groupBy'

import Loading from 'modules/core/components/Loading'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'

import { useFetchContractsTaxonomies } from 'modules/contracts/hooks/useFetchContractsTaxonomies'
import { useFetchCustomTimeRangeCategorySupplementMappings } from 'modules/payroll_bundle/hooks/useFetchReimbursableSupplementMappings'
import { useFetchTimeSettingsCustomTimeRangeCategories } from 'modules/time_categories_settings/hooks/useFetchTimeSettingsCustomTimeRangeCategories'

import TimeMappingsRow from './TimeMappingsRow'

const TimeMappingsTable = () => {
  const { company } = useCurrentSession()
  const legalEntityIds = company.legalEntities.map((legalEntity) => legalEntity.id)

  const { categories: customTimeRangeCategories, loading: loadingCategories } =
    useFetchTimeSettingsCustomTimeRangeCategories(company.id)
  const { taxonomies: supplementsTaxonomies, loading: loadingTaxonomies } =
    useFetchContractsTaxonomies(legalEntityIds)
  const { mappings, loading: loadingMappings } = useFetchCustomTimeRangeCategorySupplementMappings(
    legalEntityIds.map((id) => id)
  )
  const loading = loadingCategories || loadingTaxonomies || loadingMappings

  if (loading) return <Loading />

  const taxonomiesByLegalEntity = groupBy(
    supplementsTaxonomies.activeTaxonomies(),
    (taxonomy) => taxonomy.legalEntityId
  )

  return (
    <Box>
      <Table fullWidth>
        <Table.Head>
          <Table.Row>
            <Table.HeadCell width={200} sticky={{ position: 'left', delimiter: true }}>
              <Text.Normal weight="bold">
                {i18n.t(
                  'settings.payroll_bundle.connected_supplements.time_categories.table_title'
                )}
              </Text.Normal>
            </Table.HeadCell>
            {company.legalEntities.map((legalEntity) => (
              <Table.HeadCell width={200} key={legalEntity.id}>
                <Text.Normal weight="bold">
                  {i18n.t(
                    'app_store_v2.apps.payroll_bundle.settings.external_supplements.title_of_supplement',
                    { legal_entity: legalEntity.legalName }
                  )}
                </Text.Normal>
              </Table.HeadCell>
            ))}
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {customTimeRangeCategories.map((category) => (
            <TimeMappingsRow
              timeRangeCategory={category}
              legalEntities={company.legalEntities}
              taxonomiesByLegalEntity={taxonomiesByLegalEntity}
              mappings={mappings}
              key={`time_range_mapping_${category.id}`}
            />
          ))}
        </Table.Body>
      </Table>
    </Box>
  )
}

export default TimeMappingsTable
